import FileSaver from 'file-saver';
import { IRegulation } from '../contracts/amendment.contract';
import { ICalendarRiskGroup } from '../contracts/calendar-risk-group.contract';
import { ICalendarSurveyGroup } from '../contracts/calendar-survey-group.contract';
import ConfigService from './config.service';
import AxiosService from './axios.service';

const getByClassNumberYear = async (classNumber: string, year: number, controller: AbortController): Promise<ICalendarSurveyGroup[]> => {
    const res = await AxiosService.getInstance.get(`${ConfigService.appConfig.baseApiUrl}/VesselCalendar/GetByClassNumberYear/${classNumber}/${year}`, { signal: controller.signal });
    return res.data;
};

const getRegulationsByClassNumber = async (classNumbers: string[], controller: AbortController): Promise<IRegulation[] | undefined> => {
    const res = await AxiosService.getInstance.post(
        `${ConfigService.appConfig.baseApiUrl}/VesselCalendar/GetRegulationsByClassNumber`,
        { vesselClassNumbers: [...classNumbers] },
        { signal: controller.signal }
    );
    return res.data;
};

const getRiskByClassNumberYear = async (classNumbers: string[], year: number, controller: AbortController): Promise<ICalendarRiskGroup[]> => {
    const res = await AxiosService.getInstance.post(
        `${ConfigService.appConfig.baseApiUrl}/VesselCalendar/GetRiskByClassNumber/${year}`,
        { vesselClassNumbers: [...classNumbers] },
        { signal: controller.signal }
    );
    return res.data;
};

const downloadCalendarReport = async (type: string, fileExtension: string, imoNumbers: string[], showGuidelines: boolean): Promise<void> => {
    const requestBody = {
        ImoNumbers: imoNumbers,
        ShowGuidelines: showGuidelines
    };
    await AxiosService.getInstance.post(`${ConfigService.appConfig.baseApiUrl}/VesselCalendar/DownloadCalendarReport/${type}/${fileExtension}`, requestBody, { responseType: 'blob' }).then((res) => {
        const file = new Blob([res?.data ?? ''], { type: `${res.headers['content-type']};charset=utf-8` });
        console.log(JSON.stringify(file));
        FileSaver.saveAs(file, `Regulation_Calendar_${type}.${fileExtension}`);
    });
};

const CalendarService = {
    getByClassNumberYear,
    getRegulationsByClassNumber,
    getRiskByClassNumberYear,
    downloadCalendarReport
};

export default CalendarService;
